export enum FormFields {
  text = 'text',
}

export type FormValues = {
  [FormFields.text]: string
}
